<template>
  <v-container id="faq">
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">FAQ</v-flex>
      <v-divider insert></v-divider>
      <v-container xl5 lg6 md8 sm12 xs12 fluid grid-list-xl>
        <v-layout row wrap justify-center>
          <v-flex d-flex xs12 sm12 md8 lg8 v-for="(question, index) in questions" :key="index">
            <v-card>
              <v-card-title class="question justify-center">{{ question.title }}</v-card-title>
              <v-divider />
              <v-card-text v-html="question.answer">{{ question.answer }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      questions: [
        {
          title: 'When is the wedding?',
          answer: 'We have a date for the Wedding now! Please see the <a href="/schedule">Schedule</a>',
        },
        {
          title: 'Will the wedding be outside?',
          answer: 'We have an enclosed tent that will be set up at the Aquarium. Please see pictures <a href="https://www.weddingwire.com/biz/new-england-aquarium-boston/98cd0c5fe60aac20.html" target="_blank">here.</a>',
        },
        {
          title: 'Are there any events after the wedding?',
          answer: 'Yes! For all of those who can make it, Anan and I are planning on going to our favorite Boston Brewery, Night Shift located at <a href="https://www.google.com/maps/place/Night+Shift+Brewing+-+Everett/@42.4059707,-71.067886,15z/data=!4m2!3m1!1s0x0:0xc68b7f0434ddb595?sa=X&ved=2ahUKEwiw8o6M7_bkAhWuneAKHdJOAu4Q_BIwGHoECAkQCA" target="_blank">87 Santilli Hwy, Everett, MA 02149</a>. They will have the <a href="https://www.complimentsfood.com/" target="_blank">Compliments Food Truck</a> there as well. We will be there starting at 12pm on Sunday until about 3 pm. Feel free to stop in at any point that you can make it.',
        },
        {
          title: 'Should the bridal party wear shorts?',
          answer: 'It would be preferable if the bridal party does not wear shorts. But they can if they really want to. We wont kick anyone out.',
        },
        {
          title: 'What should other people wear, besides possibly shorts?',
          answer: 'It will be a pretty normal wedding. Most people in suits and dresses. Does not have to be too formal.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.transparent {
   background-color: white!important;
   opacity: 0.99;
   border-color: transparent!important;
 }
 .question {
   color: grey;
   font-size: 1.4rem;
   font-style: italic;
 }
</style>
